export default __webpack_public_path__ + "static/media/who.cba21b2a.png";